import { NavBar } from "@portal-frontend-ssr/navbar";
import { Outlet } from "@remix-run/react";
import { useLoaderData } from "@remix-run/react";
import { gameLayoutLoader } from "~/shared/loaders/gameLayoutLoader";

export const loader = async () => {
  return await gameLayoutLoader({ gameId: "gaming" });
};

export const Component = () => {
  const { nav, tournamentTimelineData } = useLoaderData<typeof loader>();

  return (
    <>
      <NavBar navbarItems={nav.items} tournamentTimeline={tournamentTimelineData} />
      <Outlet />
    </>
  );
};

export default Component;
